<template>
  <div class="brief">
    <div class="row">
      <!-- 左边 -->
      <div class="fl w235">
        <div class="sideTitle2">
          <div class="list-img">
            <h5>考试成绩合格查询</h5>
          </div>
          <div class="list">
            <ul>
              <li v-for="(item,index) in list" :class="isActive == index?'active': ''" :key="index"
                  @click="listClick(item.id,index)">
                <p>{{item.text}}</p>
                <i class="el-icon-arrow-right"></i>
              </li>
            </ul>
          </div>
        </div>
        <div class="sideImg">
          <img src="../../../assets/image/mxu.jpg" alt="">
        </div>
      </div>
      <!-- 右边 -->
      <div class="fr w750">
        <div class="pageBox2">
          <div class="about">
            <div class="about-header">
              <h3>成绩合格列表</h3>
              <el-button type="primary" size="mini" @click="showAllProducts">展示所有成绩合格信息</el-button>
            </div>
            <el-divider></el-divider>
            <!-- 查询表单 -->
            <div class="search-form">
              <el-form :inline="true" :model="queryParams" class="demo-form-inline">
                <el-form-item label="考生名称">
                  <el-input v-model="queryParams.name" placeholder="请输入考生名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                  <el-input v-model="queryParams.sn" placeholder="请输入完整身份证号" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="handleSearch">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
            <el-table :data="scoreList" style="width: 100%" >
              <el-table-column prop="name" label="考生名称"></el-table-column>
              <el-table-column prop="sn" label="身份证号">
                <!-- <template slot-scope="scope">
                  {{ formatIdCard(scope.row.sn) }}
                </template> -->
              </el-table-column>

              <el-table-column prop="trainTopic" label="培训名称">  </el-table-column>
              <el-table-column prop="lastScore" label="考生成绩">
                <template slot-scope="scope">
                  <span :class="{ 'pass-score': scope.row.lastScore > 60 }">
                    {{ scope.row.lastScore > 60 ? '合格' : scope.row.lastScore }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="num" label="考生编号"></el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pages">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" small
                             layout="prev, pager, next" :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      scoreList: [],
      total: 0,
      isActive: 1, // '产品列表' is the active one
      queryParams: {
        name:'',
        sn:'',
        pageNum: 1,
        pageSize: 10,
      },
      list: [{
        text: '考试成绩合格查询',
        id: 1
      },

      ]
    }
  },
  mounted() {

    this.getScoreList();
  },
  methods: {
    getScoreList() {
      this.$axios.get('/business/scoreList', { params: this.queryParams }).then(res => {
        if (res.data.rows) {
          this.scoreList = res.data.rows;
          this.total = res.data.total;
        }
      }).catch(error => {
        console.error('获取产品列表失败:', error);
      });
    },
    handleSizeChange(row) {
      this.queryParams.pageSize = row;
      this.getScoreList();
    },
    handleCurrentChange(row) {
      this.queryParams.pageNum = row;
      this.getScoreList();
    },
    listClick(id, index) {
      this.isActive = index;
      if (id == 1) {
        this.$router.push({
          path: '/scoreShow',
        });
      }
    },
    showAllProducts() {
      this.queryParams.name = '';
      this.queryParams.sn = '';
      this.queryParams.pageNum = 1;
      this.getScoreList();
    },
    handleSearch() {
      this.queryParams.pageNum = 1;
      this.getScoreList();
    },
    formatIdCard(idCard) {
      if (!idCard || idCard.length < 8) return idCard;
      // 保留前4位和后4位，中间用*号替换
      const start = idCard.substring(0, 4);
      const end = idCard.substring(idCard.length - 4);
      const middle = '*'.repeat(idCard.length - 8);
      return start + middle + end;
    }

  }
}
</script>

<style lang="scss" scoped>
.brief {
  margin: 20px 0;
  overflow: hidden;

  .row {
    width: 1000px;
    background-color: #FFF;
    margin: 0 auto;

    .w235 {
      width: 235px;
      left: -8px;

      .sideImg {
        text-align: center;
        padding: 20px 0;
      }
    }

    .w750 {
      width: 750px;
      position: relative;
      right: -7px;

      .pageBox2 {
        min-height: 830px;
        border: 1px #DDDDDD solid;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
        0 0 6px 0 rgba(0, 0, 0, 0.04);

        .about {
          padding: 45px 35px;
          line-height: 20px;
          text-align: justify;

          .about-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
          }

          h3 {
            font-size: 18px;
            color: #066FC4;
            margin-bottom: 10px;
          }
          .search-form {
            margin-bottom: 20px;
            padding: 15px;
            background-color: #f5f7fa;
            border-radius: 4px;
          }
          .pass-score {
            color: #67C23A;
            font-weight: bold;
          }
          .pages {
            padding: 20px 0;
            display: flex;
            justify-content: center;
          }
        }
      }
    }
  }
}
.el-table__row {
  cursor: pointer;
}
</style>
